import Table from '../../../table';

namespace('IO.Views.FirewallPolicies', function (exports) {
  'use strict';

  var New = Table.extend({
    dom: {
      SELECT2_FIELD: '.select2select',
    },

    onDestroy: function () {},

    render: function () {
      var $select = this.$(this.dom.SELECT2_FIELD);

      $select.select2(
        window.select2Defaults({
          acceptNotFound: false,
          allowClear: true,
          placeholder: '',
        }),
      );
    },
  });

  exports.New = New;
});
